var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRemoveModalActualite = function SvgRemoveModalActualite(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 101,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.972,
    cy: 78.592,
    r: 21.613,
    fill: "#FDEAEF",
    transform: "rotate(-90 75.972 78.592)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.887,
    cy: 21.613,
    r: 21.613,
    fill: "#FDEAEF",
    transform: "rotate(-90 24.887 21.613)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDEAEF",
    d: "m84.813 27.98 1.744-14.554 14.554 1.743-1.744 14.554zM0 87.654l3.21-14.302 14.302 3.21-3.21 14.303z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D31140",
    d: "M51.72 17.356c-18.95 0-34.364 15.13-34.364 33.729S32.77 84.814 51.72 84.814c18.95 0 34.365-15.13 34.365-33.73 0-18.598-15.415-33.728-34.365-33.728"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.235 64.593a2.9 2.9 0 0 1-2.12-.882 2.9 2.9 0 0 1-.882-2.12V42.079q-.638 0-1.07-.43a1.46 1.46 0 0 1-.43-1.07q0-.638.43-1.07.432-.431 1.07-.431h6.004q0-.638.432-1.07.431-.431 1.069-.431h6.003q.638 0 1.07.43.431.433.431 1.07h6.004q.637 0 1.068.431.432.432.432 1.07t-.432 1.07q-.43.431-1.068.431v19.512q0 1.238-.881 2.12a2.9 2.9 0 0 1-2.121.882zm3.002-7.505q0 .638.432 1.069.431.432 1.069.432t1.07-.432a1.45 1.45 0 0 0 .43-1.069V46.582q0-.638-.43-1.07a1.46 1.46 0 0 0-1.07-.43q-.638 0-1.069.43a1.45 1.45 0 0 0-.432 1.07zm6.003 0q0 .638.433 1.069.43.432 1.068.432t1.07-.432q.431-.431.431-1.069V46.582q0-.638-.43-1.07a1.46 1.46 0 0 0-1.07-.43q-.639 0-1.07.43a1.45 1.45 0 0 0-.432 1.07z"
  })));
};
export default SvgRemoveModalActualite;